//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'
import 'devextreme/ui/button'

//#endregion

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { ObjectReferenceModel } from '../../api/api.models'
import { EventsNames } from '../../../helpers/events-names'
import { CommonHelper, DataType, ViewColumnType } from '../../../helpers/common-helper'
import { GridSelectBridge } from '../../common/grid-select/grid-select.directive'
import { GridBridge } from '../../common/common.interfaces'
import { i18n } from '../i18n/common.i18n'
import { OperatorLayoutSettings } from '../../../helpers/operator-layout-settings'
import { Md5 } from '../../../helpers/md5-helper'
import { ConfirmationSource } from '../../common/confirmation-popup/confirmation-popup.directive'
import { Permissions } from '../../../helpers/permissions'
import { IUserSession } from '../../../helpers/user-session'
import { Dictionary } from '../../../helpers/dictionary'
import { Enums } from '../../../models/common/enums'
import { OpView, GetViewColumnOptions } from '../../../models/core/op-view'
import { OpViewColumn } from '../../../models/core/op-view-column'
import { OpDeviceType } from '../../../models/core/op-device-type'
import { TemplateHelper, ConfigHelper, LogHelper } from '../../../helpers'
import { IReferenceType } from '../../../models/util/interfaces'

//#region Asset Imports

import './toolbar-popover.scss'
import * as TEMPLATE from './toolbar-popover.tpl.html'

//#endregion

export interface Md5Objects {
	previousSaveRequestMd5: string
	previousElementsMd5: string
}

interface ToolbarPopoverScope extends ng.IScope {
	source: GridBridge
	bridge: GridSelectBridge
	popupVisible?: boolean

	grid: DevExpress.ui.dxDataGrid
	addButtonOptions: DevExpress.ui.dxButtonOptions
	removeButtonOptions: DevExpress.ui.dxButtonOptions
	submitButtonOptions: DevExpress.ui.dxButtonOptions
	addButtonDisabled: boolean
	removeButtonDisabled: boolean
	submitButtonDisabled: boolean
	popupTitle: string
	popupTitleUpdate: number

	added: any[]
	removed: any[]

	submitChanges(): void
	md5: Md5Objects

	id: number

	connectionsToUpdate: any[]

	confirmationSource: ConfirmationSource

	//srcServiceName: string
	//srcMethodName: string
	//objectReferenceModel: ObjectReferenceModel []
	//ifUpdateConnection: boolean
}

interface IConnect {
	srcServiceName: string
	srcMethodName: string
	objectReferenceModel: ObjectReferenceModel
}

export class ToolbarPopoverDirective implements ng.IDirective {
	requestFailed: boolean = false
	constructor() {}

	scope = {
		source: '=',
		grid: '=',
		md5: '=',
		popupVisible: '=?',
		id: '=?',
	}

	restrict = 'E'

	link = (scope, element, attrs) => {
		scope.$watch('source', (value) => {
			scope.source = value
		})
	}

	private needToSaveChanges: boolean = false

	controller = [
		'$scope',
		'$q',
		'$timeout',
		'api',
		'localDictionary',
		'$filter',
		'userSession',
		($scope: ToolbarPopoverScope, $q: ng.IQService, $timeout: ng.ITimeoutService, api: Api, localDictionary: LocalDictionaryFactory, $filter, userSession: IUserSession) => {
			$scope.added = []
			$scope.removed = []
			$scope.connectionsToUpdate = []

			$scope.popupTitle = $scope.source.title

			var prepareBridge = (allowColumnReordering: boolean = true) => {
				$scope.bridge = {
					value: null,
					elements: [],
					data: $scope.source.data,
					onSelect: (e) => {
						$timeout(() => {
							const selectedData: any[] = e.selectedRowsData
							let value = ''

							if (selectedData.length > 0) {
								if (selectedData[0].locationEquipment) {
									selectedData.forEach((item, index) => {
										if (index > 0) value += ','
										value += item.locationEquipment.serialNbr
									})
								} else {
									selectedData.forEach((item, index) => {
										if (index > 0) value += ','
										value += item[CommonHelper.nameField]
									})
								}
							}

							$scope.bridge.value = value
							$scope.bridge.elements = selectedData
						}, 0)
					},
					onDoubleRowClick: (e) => {
						$timeout(() => {
							$scope.bridge.value = ''
							$scope.bridge.elements = [e.data]
							checkBeforeAdd()
						}, 0)
					},
					dataRequest:
						$scope.source.dataScope && $scope.source.dataMethodName
							? (request): ng.IPromise<any> => {
									if ($scope.source.dataMethodName === 'getOperatorDepositoryContent') {
										const idOperator = api.login.getUser().id
										return api.users.getOperatorDepositoryContent(idOperator).then((res: any) => {
											const newRes = {
												values: res.map((el) => {
													const obj = {}
													for (let key in el.device.dynamicValues) obj[key.toLowerCase()] = el.device.dynamicValues[key]

													obj['locationEquipment'] = el
													return obj
												}),
												totalCount: res.length,
											}
											return newRes
										})
									} else {
										return api[$scope.source.dataScope][$scope.source.dataMethodName](request)
									}
							  }
							: null,

					dataSourceParser: $scope.source.dataSourceParser,
					getAvailableDataSourceMethod: $scope.source.getAvailableDataSourceMethod,

					columnRequest: (): ng.IPromise<any> => {
						if (_.size($scope.source.popoverColumns) > 0) {
							return $q.resolve($scope.source.popoverColumns)
						} else if ($scope.source.columns) {
							return $q.resolve($scope.source.columns)
						}

						return $scope.source.referenceId ? localDictionary.getActiveViewColumnsForReferenceType($scope.source.referenceId) : localDictionary[$scope.source.dictionaryMethodName]()
					},

					name: $scope.source.name,
					addPermissions: $scope.source.addPermissions,
					onAddClick: $scope.source.onAddClick,
					allowColumnReordering: allowColumnReordering,
					gridReferenceId: $scope.source.gridReferenceId,
				}
			}

			if ($scope.source.referenceId) {
				var permission = CommonHelper.permissionForMainModuleColumnsReordering($scope.source.referenceId)
				if (permission) {
					Permissions.hasPermissions([permission]).then((columnsReorderingDisabled) => {
						prepareBridge(!columnsReorderingDisabled)
					})
				} else {
					prepareBridge()
				}
			} else {
				if ($scope.source.dataScope) {
					Permissions.hasPermissions([$scope.source.dataScope.toUpperCase() + '_MODULE_MAIN_GRID_COLUMN_REORDER_DISALLOWED']).then((columnsReorderingDisabled) => {
						if ($scope.source.dataScope == 'contact' && $scope.source.dataMethodName == 'getContactGroups') {
							Permissions.hasPermissions([Permissions.ACTOR_MODULE_ACTOR_GROUPS_GRID_COLUMN_REORDER_DISALLOWED]).then((columnsReorderingDisabled) => {
								prepareBridge(!columnsReorderingDisabled)
							})
						} else prepareBridge(!columnsReorderingDisabled)
					})
				} else {
					if ($scope.source.dictionaryMethodName == 'getActivityColumnsShort') {
						Permissions.hasPermissions([Permissions.OPERATOR_MODULE_OPERATOR_SECURITY_CUSTOM_PERMISSION_GRID_COLUMN_REORDER_DISALLOWED]).then((columnsReorderingDisabled) => {
							prepareBridge(!columnsReorderingDisabled)
						})
					} else if ($scope.source.dictionaryMethodName == 'getRoleColumns') {
						Permissions.hasPermissions([Permissions.OPERATOR_MODULE_OPERATOR_SECURITY_ROLE_GRID_COLUMN_REORDER_DISALLOWED]).then((columnsReorderingDisabled) => {
							prepareBridge(!columnsReorderingDisabled)
						})
					} else prepareBridge()
				}
			}
			$scope.$watch(
				_.debounce(() => {
					let isModified = $scope.added.length + $scope.removed.length > 0

					if (!isModified) {
						isModified = hasModifiedItems()
					}

					return !isModified
				}, 10),
				(value) => {
					$scope.submitButtonDisabled = value
				}
			)

			$scope.$watch('grid._isHidden', (value) => {
				$scope.popupTitleUpdate = $scope.source.items.length + $scope.added.length - $scope.removed.length //+ " (" + $scope.source.items.length + ")"
				if (value && $scope.source.items) $scope.popupTitleUpdate = $scope.source.items.length + $scope.added.length - $scope.removed.length
				// else $scope.source.title = $scope.popupTitleUpdate ? $scope.popupTitle + " (" + $scope.popupTitleUpdate + ")" : $scope.popupTitle
			})

			$scope.$watch('source.refresh', (refresh) => {
				if (refresh) {
					$scope.source.refresh = false

					$scope.added = []
					$scope.removed = []

					$scope.source.handleSubmitButton = (isDisabled: boolean) => {
						$scope.submitButtonDisabled = isDisabled
					}
				}
			})

			var successSubmit = () => {
				this.requestFailed = false
				$scope.grid
					.option('dataSource')
					.store()
					.createQuery()
					.filter('isNew', '=', true)
					.toArray()
					.forEach((element) => {
						element['isNew'] = false
					})

				$scope.grid
					.option('dataSource')
					.store()
					.createQuery()
					.filter('isRemoved', '=', true)
					.toArray()
					.forEach((element) => {
						$scope.grid.option('dataSource').store().remove(element)
					})
				$scope.grid.refresh()
				$scope.added = []
				$scope.removed = []
				this.needToSaveChanges = false
			}

			var hasModifiedItems = () => {
				if ($scope.grid != null) {
					return _.some($scope.grid.option('dataSource').store()['_array'], (item: any) => item.isEdited)
				}

				return false
			}

			var add = () => {
				const deferred: JQueryDeferred<any> = $.Deferred<any>()
				var currentMd5 = Md5.init($scope.bridge.elements)
				if ($scope.md5.previousElementsMd5 !== currentMd5 || $scope.source.allowDublicatedRow == true) {
					$scope.md5.previousElementsMd5 = currentMd5
					if ($scope.bridge.elements.length > 0) {
						var items = $scope.grid.option('dataSource').store()['_array']
						if (_.isFunction($scope.source.onBeforeAddAll)) {
							$scope.source
								.onBeforeAddAll($scope.bridge.elements)
								.then((objects: any[]) => {
									deferred.resolve(objects)
								})
								.fail(() => {
									deferred.resolve([])
								})
						} else {
							deferred.resolve([])
						}

						deferred.then((objectArray: any[]) => {
							if (_.size(objectArray) > 0) {
								$scope.bridge.elements = objectArray
							}
							$scope.bridge.elements.forEach((e) => {
								let element: {
									[key: string]: any
								} = {}
								for (var property in e) {
									element[property] = e[property]
								}

								const checkIfExist = (item: any): boolean => {
									if (_.isFunction($scope.source.customComparing)) {
										return $scope.source.customComparing(item, element)
									} else if ('idObject' in item) {
										return item.idObject === element[CommonHelper.idField]
									} else if (_.isFunction(item.getReferenceKey)) {
										return item.getReferenceKey() === element[CommonHelper.idField]
									}

									return item['id'] === element[CommonHelper.idField]
								}

								if (_.isFunction($scope.source.onBeforeAdd)) {
									element = $scope.source.onBeforeAdd(element)
								}

								if (!items.some(checkIfExist) || $scope.source.allowDublicatedRow == true) {
									var newElement = (<any>Object).assign({}, element)
									element['uniqueRowId'] = newElement.uniqueRowId = new Date().getTime()
									$scope.added.push(element)
									newElement.isNew = true
									if ('moduleId' in newElement) {
										newElement.moduleId = OperatorLayoutSettings.getSetting(CommonHelper.isAllModulesAllowed) == true ? null : CommonHelper.webSIMAXModuleId
										newElement[CommonHelper.moduleColumnId] = newElement.moduleId
									}
									$scope.grid.option('dataSource').store().insert(newElement)
									$scope.popupTitleUpdate += 1
									// $scope.source.title = $scope.popupTitle //+ " (" /*+ $scope.source.items.length + "/" */+ $scope.popupTitleUpdate + ")"
									$scope.popupTitleUpdate = $scope.source.items.length + $scope.added.length - $scope.removed.length
								}
								if ($scope.removed.some(checkIfExist) && $scope.source.allowDublicatedRow != true) {
									for (var i = 0; i < $scope.removed.length; i++) {
										if ($scope.removed[i].id === element[CommonHelper.idField]) {
											$scope.grid.byKey($scope.removed[i].id).then((el) => {
												el.isRemoved = false
												$scope.grid.refresh()
											})
											$scope.removed.splice(i, 1)
											break
										}
									}
								}
								$scope.grid.refresh()
							})
						})
					}

					$timeout(() => {
						$scope.bridge.value = null
						$scope.bridge.elements = []
						$scope.$broadcast(EventsNames.VALUE_FROM_GRID_SELECT_ADDED)
					}, 0)
				}
			}

			var remove = () => {
				var selected = $scope.grid.getSelectedRowsData()
				if (selected.length) {
					selected.forEach((element) => {
						if (!(<any>element).isNew) {
							if ((<any>element).isRemoved) {
								$scope.popupTitleUpdate += 1
								// $scope.source.title = ($scope.source.items && $scope.popupTitleUpdate) ? $scope.popupTitle/* + " (" + $scope.source.items.length + "/" + $scope.popupTitleUpdate + ")"*/ : $scope.popupTitle
								for (var i = 0; i < $scope.removed.length; i++) {
									if ($scope.removed[i].id === element['id']) {
										$scope.removed.splice($scope.removed.indexOf(element), 1)
										;(<any>element).isRemoved = false
										break
									}
								}
							} else {
								;(<any>element).isRemoved = true
								$scope.removed.push(element)
								$scope.popupTitleUpdate -= 1
								// $scope.source.title = ($scope.source.items && $scope.popupTitleUpdate) ? $scope.popupTitle/* + " (" + $scope.source.items.length + "/" + $scope.popupTitleUpdate + ")"*/ : $scope.popupTitle
							}
							$scope.grid.refresh()
						} else {
							var store = $scope.grid.option('dataSource').store()
							store.remove(store._key ? element.id : element).then(() => {
								$scope.popupTitleUpdate -= 1
								$scope.source.title =
									$scope.source.items && $scope.popupTitleUpdate ? $scope.popupTitle /* + " (" + $scope.source.items.length + "/" + $scope.popupTitleUpdate + ")"*/ : $scope.popupTitle
								$scope.grid.refresh()
							})
							$scope.added.splice($scope.added.indexOf(element), 1)
						}
					})
				}
				$scope.md5.previousElementsMd5 = ''
			}

			let nowInGrid: any[]
			var submitChanges = () => {
				//$scope.ifUpdateConnection = ($scope.srcServiceName && $scope.srcMethodName) ? true : false
				var currentMd5 = Md5.init({ added: $scope.added, removed: $scope.removed, connect: $scope.connectionsToUpdate, nowInGrid })
				if ($scope.md5.previousSaveRequestMd5 !== currentMd5 || this.requestFailed) {
					$scope.md5.previousSaveRequestMd5 = currentMd5
					$scope.submitButtonDisabled = true

					if (($scope.source.onApply != null || $scope.source.onSubmit != null) && ($scope.added.length || $scope.removed.length || this.needToSaveChanges || hasModifiedItems())) {
						if ($scope.source == null || !$scope.source.isLoadingIndicatorDisabled) {
							$scope.$root.$broadcast('showLoadingIndicator')
						}

						setTimeout(() => {
							//need timeout to update grid cells values if user after edition directly clicks on submit
							var dataSource: DataSource = $scope.grid.option('dataSource')
							var items = dataSource.store()['_array']

							nowInGrid = $filter('orderBy')(items, 'VisibleIndex')

							var dataSubmited = (result) => {
								if (result) {
									$scope.popupTitleUpdate = $scope.source.items.length + $scope.added.length - $scope.removed.length
									$scope.source.title = $scope.popupTitle

									successSubmit()
								} else {
									this.requestFailed = true
								}
								$timeout(() => {
									$scope.popupTitleUpdate = $scope.source.items.length
								})
							}

							const handleError: (error: any) => void = (error: any) => {
								if (error != null && error.promise != null && typeof error.promise == 'object') {
									error.promise.then(dataSubmited).catch((e: any) => {
										this.requestFailed = true
									})
								}
								this.requestFailed = true
							}

							const handleFinally: () => void = () => {
								if ($scope.source == null || !$scope.source.isLoadingIndicatorDisabled) {
									$scope.$root.$broadcast('hideLoadingIndicator')
								}
								$scope.submitButtonDisabled = false
							}

							if ($scope.source.onApply) {
								$scope.source.onApply($scope.added, $scope.removed, nowInGrid).then(dataSubmited).fail(handleError).always(handleFinally)
							} else {
								$scope.source.onSubmit($scope.added, $scope.removed, nowInGrid).then(dataSubmited).catch(handleError).finally(handleFinally)
							}
						}, 500)
					}
				}
			}

			var checkBeforeAdd = () => {
				$.when<any>(
					userSession.getDataProvider().View.getActiveView(Enums.ReferenceType.SerialNbr),
					userSession.getDataProvider().View.getActiveView(Enums.ReferenceType.IdLocation),
					userSession.getDataProvider().System.getDictionaries([Enums.ReferenceType.IdDeviceType])
				).then((deviceView: OpView, locationView: OpView, dicts: Dictionary<Dictionary<IReferenceType>>) => {
					let deviceColumn: OpViewColumn = null
					let meterColumn: OpViewColumn = null

					if (deviceView != null) {
						deviceColumn = deviceView.getViewColumn(new GetViewColumnOptions(Enums.DataType.HELPER_SERIAL_NBR))
					}

					if (locationView != null) {
						meterColumn = locationView.getViewColumn(new GetViewColumnOptions(Enums.DataType.HELPER_ID_METER))
					}

					if (deviceColumn == null || meterColumn == null) {
						LogHelper.warn('[SIMAX.Common.ToolbarPopover]', 'Missing HELPER_ID_METER or HELPER_SERIAL_NBR columns in location view.')

						add()

						return
					}

					const deviceColumnName: string = deviceColumn.name.toLowerCase()
					const meterColumnName: string = meterColumn.name.toLowerCase()

					const idDeviceType: number = _.first(
						$scope.bridge.elements
							.filter((item: any) => deviceColumnName && item[deviceColumnName] == item[CommonHelper.idField] && item[CommonHelper.idReferenceField] != null)
							.map((item: any) => Number(item[CommonHelper.idReferenceField]).valueOf())
					)

					const deviceType: OpDeviceType =
						_.isNumber(idDeviceType) && idDeviceType > 0 && dicts != null && dicts.tryGetValue(Enums.ReferenceType.IdDeviceType) != null
							? (dicts.tryGetValue(Enums.ReferenceType.IdDeviceType).tryGetValue(idDeviceType) as OpDeviceType)
							: null

					const deviceTypeIsSet: boolean = deviceType != null && deviceType.dataList != null && deviceType.dataList.getValue(Enums.DataType.DEVICE_TYPE_IS_SET, 0, false)

					var deviceWithMeter: boolean = $scope.bridge.elements.some((item) => {
						if (deviceColumnName && item[deviceColumnName] == item[CommonHelper.idField]) {
							if (meterColumnName && item[meterColumnName]) return true
							else return false
						} else return false
					})

					if (deviceWithMeter != true) {
						var meterWithDevice: boolean = $scope.bridge.elements.some((item) => {
							if (meterColumnName && item[meterColumnName] == item[CommonHelper.idField]) {
								if (deviceColumnName && item[deviceColumnName]) return true
								else return false
							} else return false
						})
						if (meterWithDevice != true) add()
						else {
							//we are adding METER with device
							$scope.confirmationSource = {
								confirmYes: () => {
									add()
								},
								confirmNo: () => {
									$scope.bridge.elements = $scope.bridge.elements.map((item) => {
										item = (<any>Object).assign({}, item)
										var meterView: OpView = localDictionary.getActiveView([CommonHelper.IdMeter])
										var deviceColumns = meterView.columns.filter((item) => {
											return item.table == 'DEVICE'
										})

										for (var field in item) {
											if (
												deviceColumns.some((item) => {
													return item.name.toLowerCase() == field
												})
											) {
												item[field] = null
											}
										}
										return item
									})
									add()
								},
							}

							$scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + $scope.id, i18n('Popup', 'AddMeterWithDevice'))
						}
					} else {
						//we are adding DEVICE with meter

						if (deviceTypeIsSet || $scope.source.name == 'meterDevicesGrid') {
							add()
						} else {
							$scope.confirmationSource = {
								confirmYes: () => {
									add()
								},
								confirmNo: () => {
									$scope.bridge.elements = $scope.bridge.elements.map((item) => {
										item = (<any>Object).assign({}, item)
										var deviceView: OpView = localDictionary.getActiveView([CommonHelper.IdDevice])
										var meterColumns = deviceView.columns.filter((item) => {
											return item.table == 'METER'
										})
										for (var field in item) {
											if (
												meterColumns.some((item) => {
													return item.name.toLowerCase() == field
												})
											) {
												item[field] = null
											}
										}
										return item
									})
									add()
								},
							}

							$scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + $scope.id, i18n('Popup', 'AddDeviceWithMeter'))
						}
					}
				})
			}

			$scope.addButtonDisabled = true
			$scope.removeButtonDisabled = true
			$scope.submitButtonDisabled = true

			var isNewSelected = () => {
				if ($scope.bridge != null) {
					return _.size($scope.bridge.elements) > 0
				}

				return false
			}
			var isInstalledSelected = () => {
				return $scope.grid ? $scope.grid.getSelectedRowKeys().length != 0 : false
			}

			$scope.submitButtonOptions = {
				text: i18n('Common', 'Apply'),
				onClick: submitChanges,
				bindingOptions: {
					disabled: 'submitButtonDisabled',
				},
			}

			$scope.addButtonOptions = {
				template: TemplateHelper.getIcon(ConfigHelper.Icon.ADD, userSession),
				onClick: checkBeforeAdd,
				bindingOptions: {
					disabled: 'addButtonDisabled',
				},
			}

			$scope.removeButtonOptions = {
				template: TemplateHelper.getIcon(ConfigHelper.Icon.REMOVE, userSession),
				onClick: remove,
				bindingOptions: {
					disabled: 'removeButtonDisabled',
				},
			}

			$scope.$watch(isNewSelected, (value) => {
				$scope.addButtonDisabled = !value
			})
			$scope.$watch(isInstalledSelected, (value) => {
				$scope.removeButtonDisabled = !value
			})

			$scope.$on(EventsNames.ROUTE_POINT_DRAG_AND_DROP + $scope.source.id, (event: ng.IAngularEvent, ...args: any[]) => {
				$scope.submitButtonDisabled = false
				$scope.md5.previousSaveRequestMd5 = ''
				this.needToSaveChanges = true
			})

			$scope.$on(EventsNames.USER_CUSTOM_ACTIVITY_CHANGED, (event: ng.IAngularEvent, ...args: any[]) => {
				$scope.submitButtonDisabled = false
				this.needToSaveChanges = true
			})

			$scope.$on(EventsNames.CONNECT_TO_LOCATION, (event: ng.IAngularEvent, ...args: any[]) => {
				var connect: IConnect = {
					srcServiceName: args[0],
					srcMethodName: args[1],
					objectReferenceModel: args[2],
				}
				var selectedItem = args[3]

				let meterIdName = localDictionary.getViewColumnName(CommonHelper.IdDevice, DataType.HELPER_ID_METER, ViewColumnType.BaseHelper).toLowerCase()
				let meterTypeName = localDictionary.getViewColumnName(CommonHelper.IdDevice, DataType.HELPER_ID_METER_TYPE, ViewColumnType.BaseHelper).toLowerCase()
				let deviceIdName = localDictionary.getViewColumnName(CommonHelper.IdDevice, DataType.HELPER_SERIAL_NBR, ViewColumnType.BaseHelper).toLowerCase()

				var list: any[] = $scope.grid.option('dataSource').store()['_array']
				list.forEach((item) => {
					if (item.id == connect.objectReferenceModel.id) {
						if (selectedItem[meterIdName]) item[meterIdName] = selectedItem[meterIdName]
						if (selectedItem[meterTypeName]) item[meterTypeName] = selectedItem[meterTypeName]
						if (selectedItem[deviceIdName]) item[deviceIdName] = selectedItem[deviceIdName]
					}
				})
				$scope.grid.option({ dataSource: new DataSource(list) })

				$scope.connectionsToUpdate.push(connect)
				$scope.submitButtonDisabled = false
				this.needToSaveChanges = true
			})

			$scope.$watch('grid', (grid) => {
				if (grid) {
					;(<any>grid).option({
						onRowPrepared: (e: any) => {
							if (e.rowType == 'data') {
								if (e.data.isNew) {
									$(e.rowElement).css('font-style', 'italic')
								} else if (e.data.isRemoved) {
									$(e.rowElement).css('text-decoration', 'line-through')
								} else if (e.data.isEdited) {
									$(e.rowElement).css('font-weight', 'bold')
								}
								e.rowElement.addClass('myRow').data('keyValue', e.key)
							}
						},
					})
				}
			})

			$scope.$on('equipmentReadyToAssign', () => {
				successSubmit()
			})
		},
	]

	template = TEMPLATE
}
